<template>
  <v-app>
    <v-app-bar app>
      <v-toolbar-title class="headline text-uppercase">
        <span>Archipelago.ai</span>
        <span class="font-weight-light"
          >Updating automatically from github</span
        >
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn text href="https://twitter.com/rickygervais" target="_blank">
        <span class="mr-2">Twitter</span>
      </v-btn>
    </v-app-bar>

    <v-content>
      <HelloWorld />
      <Card />
      <v-btn text href="https://twitter.com/rickygervais" target="_blank">
        <span class="mr-2">Twitter</span>
      </v-btn>
    </v-content>
  </v-app>
</template>

<script>
import HelloWorld from "./components/HelloWorld";
import Card from "./components/Card";

export default {
  name: "App",
  components: {
    HelloWorld,
    Card
  },
  data: () => ({
    //
  })
};
</script>
